import { Button } from "@repo/ui";
import { useAuth } from "@stardeck-customer-apps/project-auth";

export default function AdminDashboard() {
  const { signOut } = useAuth();

  return (
    <div className="min-h-dvh grid place-items-center px-6 py-20">
      <div className="text-center space-y-6">
        <h1 className="text-3xl font-semibold tracking-tight">Admin</h1>
        <p className="text-muted-foreground">You're signed in.</p>
        <div>
          <Button onClick={() => signOut()}>Sign Out</Button>
        </div>
      </div>
    </div>
  );
}
